import React, { FC } from "react";
import memoize from "utils/memoize";
import {
  RHFormConsumerTextField,
  RHFormConsumerTextFieldProps
} from "component-rh-text-field/RHFormConsumerTextField";
import { countryZipCodesRegex } from "utils/regex";

export const PostalCodeField: FC<
  RHFormConsumerTextFieldProps & { countryCode?: string }
> = ({ countryCode, ...props }) => (
  <RHFormConsumerTextField
    defaultValue=""
    rules={{
      ...(props.required
        ? {
            required:
              props.errorMessages?.["postalCodeRequired"] ||
              "Postal code required."
          }
        : null),
      ...(countryCode
        ? {
            pattern: {
              value: countryZipCodesRegex[countryCode],
              message:
                props.errorMessages?.["invalidZipCode"] ||
                "Invalid zip/postal code."
            }
          }
        : null)
    }}
    name={"postalCode"}
    fullWidth
    label={props.label || "Postal Code"}
    {...props}
  />
);

export default memoize(PostalCodeField);
